// =============================================================================
// FILE: packages/renderer/src/lib/celebration.ts
// PURPOSE: "Launch Celebration" trial logic. Free access for everyone until the
//          founder's birthday (October 20). Verified RCDDs & Master Admins get
//          unlimited access; all other users get metered limits (AI credits /
//          exports / projects). Usage is tracked in localStorage for the web
//          preview. After the birthday, the app transitions to subscriptions.
// =============================================================================

/** Campaign end — founder's birthday, October 20. Uses the upcoming Oct 20. */
export function campaignEndDate(now: Date = new Date()): Date {
  const year = now.getMonth() > 9 || (now.getMonth() === 9 && now.getDate() > 20)
    ? now.getFullYear() + 1
    : now.getFullYear();
  return new Date(year, 9, 20, 23, 59, 59); // month 9 = October
}

export function daysUntilCampaignEnd(now: Date = new Date()): number {
  return Math.max(0, Math.ceil((campaignEndDate(now).getTime() - now.getTime()) / 86_400_000));
}

export function isCampaignActive(now: Date = new Date()): boolean {
  return now.getTime() <= campaignEndDate(now).getTime();
}

export const FREE_LIMITS = { aiPerDay: 5, exportsTotal: 5, projects: 2 } as const;

// ── Usage tracking (localStorage) ─────────────────────────────────────────────
const K_AI = 'rcd2.usage.ai';
const K_EXPORT = 'rcd2.usage.exports';
const K_PROJECT = 'rcd2.usage.projects';

function todayKey(): string { return new Date().toISOString().slice(0, 10); }

export function aiCreditsUsedToday(): number {
  try {
    const raw = JSON.parse(localStorage.getItem(K_AI) ?? '{}') as { date?: string; count?: number };
    return raw.date === todayKey() ? (raw.count ?? 0) : 0;
  } catch { return 0; }
}

export function consumeAiCredit(): void {
  const used = aiCreditsUsedToday();
  try { localStorage.setItem(K_AI, JSON.stringify({ date: todayKey(), count: used + 1 })); } catch { /* */ }
}

function counter(key: string): number {
  try { return Number(localStorage.getItem(key) ?? '0') || 0; } catch { return 0; }
}
export const exportsUsed  = (): number => counter(K_EXPORT);
export const projectsUsed = (): number => counter(K_PROJECT);
export function consumeExport(): void  { try { localStorage.setItem(K_EXPORT, String(exportsUsed() + 1)); } catch { /* */ } }
export function consumeProject(): void { try { localStorage.setItem(K_PROJECT, String(projectsUsed() + 1)); } catch { /* */ } }
